import type { 
  PostReportsData,
  PostReportsResponse,

  PostReportsSpecialPaymentSystemsData,
  PostReportsSpecialPaymentSystemsResponse,

  GetReportsShortUrlByIdData,
  GetReportsShortUrlByIdResponse,

  PostReportsShortUrlData,
  PostReportsShortUrlResponse,

  PostReportsCohortData,
  PostReportsCohortResponse
} from "@/types/openapi-ts";

import type { AxiosInstance } from "axios";

export function getReportsApiModule(affiliatesApi: AxiosInstance) {
  return {
    getMainReport(params: PostReportsData['body'] | PostReportsData['body'][string]) {
      return affiliatesApi.post<PostReportsResponse>('/reports', params);
    },
    // getPanelSettings() {
    //   return affiliatesApi.get('/reports/panel-settings');
    // },
    // getReportsSettings() {
    //   return affiliatesApi.get('/reports/settings');
    // },
    getPaymentsReport(params: PostReportsSpecialPaymentSystemsData['body']) {
      return affiliatesApi.post<PostReportsSpecialPaymentSystemsResponse>('/reports/special/payment-systems', params);
    },
    getShortUrlRequest(path: string) {
      return affiliatesApi.get<GetReportsShortUrlByIdResponse>(`/reports/short-url/${path}`);
    },
    postQueryShortUrl(query: PostReportsShortUrlData['body']) {
      return affiliatesApi.post<PostReportsShortUrlResponse>('/reports/short-url', { query });
    },
    getCohortReport(params: PostReportsCohortData['body']) {
      return affiliatesApi.post<PostReportsCohortResponse>('/reports/cohort', params);
    },
  }
}
